import { Accounting } from '@reporting/rp-types/core';
import { Service } from './service';

export class AccountingProvider {

	private _a: number;
	get a() { return this._a }
	set a(a: number) {
		this._a = a;
		if (this.accounting?.accounting != a) {
			this._accounting = null;
		}
	}

	private _accounting: Accounting;
	get accounting() { return this._accounting }
	set accounting(accounting: Accounting) {
		this._a = accounting.accounting;
		this._accounting = accounting;
	}

	constructor(private client: Service = null) { }

}
